import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-flash-coupon',
  templateUrl: './edit-flash-coupon.component.html',
  styleUrls: ['./edit-flash-coupon.component.css']
})
export class EditFlashCouponComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/flash/flash-coupons/edit-flash-coupon/edit-flash-coupon.component.ts